import CharacterMappingTable from './CharacterMappingTable'

export default CharacterMappingTable
